function promotionPopupAutoBlocked(doc, win, popup) {
  if (win.Shopify?.designMode || doc.hidden || doc.body.classList.contains('template-cart') || doc.querySelector('.cart-page, .product-page--floor-mats')) return true;
  if (doc.activeElement?.closest?.('input, textarea, select, [contenteditable="true"], [role="textbox"]')) return true;
  if (doc.documentElement.classList.contains('drawer-open') || doc.querySelector('.drawer-layer.is-open, .search-panel.is-open, .card-nav.is-open')) return true;
  if (Array.from(doc.querySelectorAll('dialog[open], [role="dialog"]')).some((element) => element !== popup && !element.closest('[aria-hidden="true"]') && element.getClientRects().length)) return true;
  if (Array.from(doc.querySelectorAll('#shopify-pc__banner, #onetrust-banner-sdk, .cc-window, [data-cookie-consent], [data-cookie-banner]')).some((element) => element.getClientRects().length)) return true;
  return false;
}

(() => {
  const init = () => {
    const trigger = document.querySelector('[data-promotion-open]');
    const popup = document.querySelector('[data-promotion-dialog]');
    if (!trigger || !popup || typeof popup.showModal !== 'function') return;

    const storageKey = 'zolvwerk-tiered-savings-popup-seen';
    let returnFocus = trigger;
    let openedThisPage = false;
    const remember = () => {
      try {
        window.sessionStorage.setItem(storageKey, '1');
        return true;
      } catch {
        return false;
      }
    };
    const open = (automatic = false) => {
      if (popup.open || (automatic && !remember())) return;
      const focused = document.activeElement;
      returnFocus = focused && focused !== document.body && focused.isConnected ? focused : trigger;
      try {
        popup.showModal();
      } catch {
        return;
      }
      openedThisPage = true;
      if (!automatic) remember();
      popup.querySelector('[data-promotion-close]')?.focus();
    };

    trigger.addEventListener('click', () => open());
    popup.querySelectorAll('[data-promotion-close]').forEach((button) => button.addEventListener('click', () => popup.close()));
    popup.addEventListener('click', (event) => {
      if (event.target !== popup) return;
      const bounds = popup.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) popup.close();
    });
    popup.addEventListener('close', () => {
      (returnFocus.isConnected ? returnFocus : trigger).focus({ preventScroll: true });
    });

    try {
      if (window.sessionStorage.getItem(storageKey) === '1') return;
    } catch {
      return;
    }
    window.setTimeout(() => {
      if (!openedThisPage && !promotionPopupAutoBlocked(document, window, popup)) open(true);
    }, 5000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
